import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, GraduationCap } from "lucide-react";
import api from "../lib/api";
import { useSEO } from "../components/site/Reveal";

export default function CourseSuccess() {
  useSEO("Enrolment Confirmed", "Thank you for enrolling with ÀsÀNigHT Worldwide.");
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const paidVia = params.get("paid");
  const [state, setState] = React.useState(paidVia ? "paid" : "checking");
  const pollRef = React.useRef(null);
  const tries = React.useRef(0);

  React.useEffect(() => {
    if (paidVia) return;
    if (!sessionId) { setState("error"); return; }
    const check = async () => {
      tries.current += 1;
      try {
        const { data } = await api.get(`/shop/order/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); clearInterval(pollRef.current); }
        else if (tries.current > 8) { setState("pending"); clearInterval(pollRef.current); }
      } catch { if (tries.current > 8) { setState("error"); clearInterval(pollRef.current); } }
    };
    check();
    pollRef.current = setInterval(check, 2500);
    return () => clearInterval(pollRef.current);
  }, [sessionId, paidVia]);

  return (
    <div className="min-h-screen grid place-items-center px-6 py-28 bg-night">
      <div className="text-center max-w-lg" data-testid="course-success">
        {state === "checking" ? (
          <><Loader2 className="w-12 h-12 text-gold animate-spin mx-auto mb-6" /><h1 className="font-serif text-3xl text-cream">Confirming your payment…</h1></>
        ) : state === "paid" ? (
          <>
            <CheckCircle2 className="w-16 h-16 text-emerald-400 mx-auto mb-6" />
            <h1 className="font-serif text-4xl text-cream mb-3">Ẹ ṣé! You're Enrolled</h1>
            <p className="text-cream/70 mb-8">Thank you for enrolling. A receipt has been sent to your email, and we'll be in touch shortly with your course access and next steps.</p>
            <Link to="/courses" className="inline-flex items-center gap-2 bg-gold text-night font-semibold px-6 py-3 rounded-full"><GraduationCap className="w-4 h-4" /> Back to Courses</Link>
          </>
        ) : state === "pending" ? (
          <><h1 className="font-serif text-3xl text-cream mb-3">Payment Processing</h1><p className="text-cream/70 mb-8">Your payment is being processed. You'll receive a confirmation email shortly.</p><Link to="/courses" className="inline-flex bg-gold text-night font-semibold px-6 py-3 rounded-full">Back to Courses</Link></>
        ) : (
          <><h1 className="font-serif text-3xl text-cream mb-3">Something went wrong</h1><p className="text-cream/70 mb-8">We couldn't confirm this enrolment. If you were charged, please contact us.</p><Link to="/courses" className="inline-flex bg-gold text-night font-semibold px-6 py-3 rounded-full">Back to Courses</Link></>
        )}
      </div>
    </div>
  );
}
